import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
  Button,
  TextField,
  Box,
} from '@material-ui/core';
import React, { useState } from 'react';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import { trim, parseInt } from 'lodash';
import { alertError } from '../../Util/Util';
import Swal from 'sweetalert2';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import KeyboardReturnRoundedIcon from '@material-ui/icons/KeyboardReturnRounded';
import qrcodeLogo from '../../images/qrcode_logo.png';
import { saveAs } from 'file-saver';
import QrCodeWithLogo from 'qrcode-with-logos';

const BonusProductQRCodeGroupAddModal = (props) => {
  const { close, isOpen, refreshList } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [isLoading, setIsLoading] = useState(false);
  const [quantity, setQuantity] = useState('');
  const [createdResult, setCreatedResult] = useState();

  const createQRCodeGroups = () => {
    if (trim(quantity) === '' || parseInt(quantity, 10) <= 0) {
      Swal.fire({
        title: '請輸入正確的數量',
        icon: 'warning',
      });

      return;
    }

    setIsLoading(true);

    bonusProductAPI
      .createQRCodeGroups(parseInt(quantity, 10))
      .then(
        (rs) => {
          Swal.fire({
            title: '新增成功',
            icon: 'success',
          });

          setCreatedResult(rs);
          refreshList();
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      returnQuantity();
      close();
    }
  };

  const handleChangeQuantity = (e) => {
    const numberTest = /^[0-9\b]+$/;
    const value = trim(e.target.value);

    if (value === '' || numberTest.test(value)) {
      setQuantity(value);
    }
  };

  const returnQuantity = () => {
    setCreatedResult(undefined);
    setQuantity('');
  };

  const handleDownloadAllQRCode = () => {
    if (!createdResult) {
      Swal.fire({
        title: '請先新增完成後再進行下載',
        icon: 'warning',
      });

      return;
    }

    const zip = require('jszip')();

    getAllUrlQrcodeImg(createdResult).then((allQrCodeImg) => {
      for (let urlQrCode of allQrCodeImg) {
        zip.file(urlQrCode.name, urlQrCode.img.split('base64,')[1], {
          base64: true,
        });
      }

      return zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, 'GROUP-QRCODE.zip');
      });
    });
  };

  const getAllUrlQrcodeImg = async (nodes) => {
    let qrcodes = [];

    for (let node of nodes) {
      const fileName =
        `GroupQRCode-${node.groupId}-${node.qRCodeValue}` + '.png';
      const qrcodeCanvas = document.createElement('canvas');
      const qrcode = new QrCodeWithLogo({
        canvas: qrcodeCanvas,
        content: node.qRCodeValue,
        width: 200,
        logo: qrcodeLogo,
      });

      await qrcode.toCanvas().then(() => {
        qrcodes.push({
          name: fileName,
          img: qrcodeCanvas.toDataURL('image/png'),
        });
      });
    }

    return qrcodes;
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={handleClose}
      fullWidth={true}>
      <DialogTitle>新增紙本序號打包 QRCODE</DialogTitle>

      <DialogContent>
        {!createdResult ? (
          <Box display="flex" flexDirection="column" gridGap="16px">
            <TextField
              label="新增數量"
              variant="standard"
              value={quantity}
              onChange={handleChangeQuantity}
              fullWidth
              disabled={isLoading}
            />
            <Button
              color="primary"
              startIcon={<AddCircleOutlinedIcon />}
              variant="contained"
              onClick={createQRCodeGroups}
              fullWidth
              disabled={isLoading}>
              新增
            </Button>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gridGap="16px">
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetAppRoundedIcon />}
              disabled={isLoading}
              onClick={handleDownloadAllQRCode}>
              下載建立完成的 QRCode
            </Button>

            <Button
              variant="contained"
              color="default"
              startIcon={<KeyboardReturnRoundedIcon />}
              disabled={isLoading}
              onClick={returnQuantity}>
              繼續新增
            </Button>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button color="primary" onClick={close} disabled={isLoading}>
          關閉
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BonusProductQRCodeGroupAddModal;
